const SET_SINGLE_TEMPLATE = "SET_SINGLE_TEMPLATE";
export const setSingleTemplate = (singleTemplate) => ({
  type: SET_SINGLE_TEMPLATE,
  payload: { singleTemplate },
});

export const singleTemplateReducer = (state = [], { type, payload }) => {
  switch (type) {
    case SET_SINGLE_TEMPLATE:
      return payload.singleTemplate;
    default:
      return state;
  }
};
